import { AiFillCloseCircle } from "react-icons/ai";
import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { useAdmin } from "../../../context/admin";
import { useGlobal } from "../../../context/global";
import AdminService from "../../../services/admin.service";
import Modal from "../../common/Modal";
import GeneralInput from "../../common/GeneralInput";
import Select from "../../common/Select";
import { CashCategory } from "../../../types/common.types";

export default function CreatePendingPayment() {
    const { setIsLoading } = useGlobal()
    const { setIsCreatePendingPaymentModalOpen } = useAdmin()
    const [categories, setCategories] = useState<CashCategory[]>([])
    const [categoryId, setCategoryId] = useState('')
    const [counterpartName, setCounterpartName] = useState('')
    const [totalAmount, setTotalAmount] = useState('')
    const [notes, setNotes] = useState('')

    useEffect(() => {
        AdminService.listCashCategories('egreso').then(res => setCategories(res.data)).catch(console.log)
    }, [])

    async function onSubmit(e: FormEvent<HTMLFormElement>) {
        e.preventDefault()
        setIsLoading(true)
        try {
            await AdminService.createCashPendingPayment({
                category_id: categoryId,
                counterpart_name: counterpartName,
                total_amount: Number(totalAmount),
                notes: notes || undefined,
            })
            window.location.reload()
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Modal onSubmit={onSubmit}>
            <h1>Nuevo pago pendiente</h1>
            <p>Para pagos que se completan en varios abonos (sueldos, comisiones, etc.).</p>
            <div className="input-container" style={{ marginTop: '15px' }}>
                <Select
                    label="Categoría"
                    required
                    defaultNull
                    value={categoryId}
                    options={categories.map(c => ({ value: c.id, name: c.name }))}
                    onChange={(e: ChangeEvent<HTMLSelectElement>) => setCategoryId(e.target.value)}
                />
                <GeneralInput
                    label="Contraparte"
                    required
                    value={counterpartName}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setCounterpartName(e.target.value)}
                />
            </div>
            <div className="input-container">
                <GeneralInput
                    label="Total a pagar"
                    type="number"
                    required
                    value={totalAmount}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setTotalAmount(e.target.value)}
                />
                <GeneralInput
                    label="Notas (opcional)"
                    value={notes}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setNotes(e.target.value)}
                />
            </div>
            <div className="actions">
                <button>Crear</button>
            </div>
            <div className="close" onClick={() => setIsCreatePendingPaymentModalOpen(false)}>
                <AiFillCloseCircle />
            </div>
        </Modal>
    )
}
